import { useState } from 'react';
import { Map, MapMarker, useMap } from 'react-kakao-maps-sdk';

const KakaoMapNear = ({ myLocation, listLocation }) => {
    const EventMarkerContainer = ({ position, content, url }) => {
        const map = useMap();
        const [isVisible, setIsVisible] = useState(false);

        return (
            <MapMarker
                position={position}
                onClick={(marker) => {
                    map.panTo(marker.getPosition());
                    setIsVisible(true);
                }}
                onMouseOver={() => setIsVisible(true)}
                onMouseOut={() => setIsVisible(false)}
            >
                {isVisible && (
                    <div
                        style={{
                            padding: '5px 10px',
                            background: 'white',
                            width: '150px',
                            textAlign: 'center',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            window.location.href = url;
                            // or window.open(url, '_blank');
                        }}
                    >
                        {content}
                    </div>
                )}
            </MapMarker>
        );
    };

    return (
        <Map // 지도를 표시할 Container
            id="map"
            center={{
                // 지도의 중심좌표
                lng: myLocation.pointX,
                lat: myLocation.pointY,
            }}
            style={{
                width: '100%',
                height: '100%',
            }}
            level={3}
            draggable={true}
            scrollwheel={true}
        >
            <MapMarker
                position={{
                    lat: myLocation.pointY,
                    lng: myLocation.pointX,
                }}
                image={{
                    src: 'https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/markerStar.png', // 마커이미지의 주소입니다
                    size: {
                        width: 24,
                        height: 35,
                    }, // 마커이미지의 크기입니다
                }}
            ></MapMarker>
            {listLocation.map((item, index) => (
                <EventMarkerContainer
                    key={`EventMarkerContainer-${index}`}
                    position={{
                        lat: item.pointY,
                        lng: item.pointX,
                    }}
                    // @ts-ignore
                    content={item.companyName}
                    url={`/paeaa070-${item.seq}`}
                />
            ))}
        </Map>
    );
};

export default KakaoMapNear;
